<template>
  <div
    v-if="filterData.length > 0"
    id="other-filters-container"
    class="flex-column-layout"
  >
    <UiDivider :type="'primary'" />
    <AccordionCard :title="$t('products.filters.others')">
      <div class="swa-checkbox-container">
        <UiCheckbox
          v-for="(otherFilter, index) in filterData"
          :id="otherFilter.slugUrl"
          :key="otherFilter.slugUrl"
          :model-value="selectedFilterParams.others"
          class="checkbox-option"
          :native-value="otherFilter.slugUrl"
          :label="$t(`products.filters.${otherFilter.name}`)"
          @update:model-value="onFilterUpdate($event, otherFilter, index)"
        />
      </div>
    </AccordionCard>
  </div>
</template>

<script lang="ts" setup>
import UiCheckbox from '@sephora-asia/ui-checkbox'
import UiDivider from '@sephora-asia/ui-divider'
import AccordionCard from './accordion-card.vue'
import type { OtherFilters } from '~/types/api/data/product/filter/filter.types'
import useFilterTrackingEvent from '~/composables/utils/product-listing/filter/use-product-listing-filter-tracking'

defineProps<{
  filterData: OtherFilters[]
}>()

const { selectedFilterParams } = useProductListingFiltersStore()
const { trackFilterClicked } = useFilterTrackingEvent()

function onFilterUpdate(
  event: string[],
  otherFilter: OtherFilters,
  index: number
) {
  trackFilterClicked(event, {
    value: otherFilter.slugUrl,
    slugUrl: otherFilter.slugUrl,
    filterIndex: index,
    filterCategoryIndex: 2,
    type: 'other',
  })
}
</script>

<style lang="scss" scoped></style>
